import { NgModule } from '@angular/core';
import { MeRegisterComponent } from './me-register.component';
import { BaseModule } from '../../shared/base.module';
import { StoryBlokLinkModule } from '../../shared/storyblok/link/link.module';
import { MeRegisterRoutesModule } from './me-register.routes';
import { MeRegisterHelpCardComponent } from './help-card/help-card.component';
import { MeRegisterWarningardComponent } from './warning-card/warning-card.component';
import { MeRegistrationPrivacyCardComponent } from './registration-privacy-card/registration-privacy-card.component';
import { MeRegisterVoucherCardComponent } from './voucher-card/voucher-card.component';
import { MeRegisterFormComponent } from './register-form/register-form.component';
import { MeRegisterVerificationModule } from '../success/register-verification/register-verification.module';
import { MeRegistrationSuccessModule } from '../success/registration-success/registration-success.module';
import { MeSetPasswordComponent } from './set-password/set-password.component';
import { MeRegisterService } from './me-register.service';


@NgModule({
    imports: [
        BaseModule,
        MeRegisterVerificationModule,
        MeRegistrationSuccessModule,
        MeRegisterRoutesModule,
        StoryBlokLinkModule
    ],
    declarations: [
        MeRegisterFormComponent,
        MeSetPasswordComponent,
        MeRegisterVoucherCardComponent,
        MeRegisterHelpCardComponent,
        MeRegistrationPrivacyCardComponent,
        MeRegisterWarningardComponent,
        MeRegisterComponent
    ],
    exports: [
        MeRegisterComponent
    ]
})
export class MeRegisterModule { }
